import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { SAMPLE_FULL } from "@/data/sample";

export default function ExampleModal({ open, onOpenChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="example-modal"
        aria-describedby="example-desc"
        className="bg-paper border-0 max-w-2xl max-h-[85vh] overflow-y-auto rounded-3xl p-0"
      >
        <div className="p-10 md:p-14">
          <DialogHeader>
            <div className="font-display tracking-[0.3em] text-[10px] text-umber">
              Beispiel-Entwurf · Vollständig
            </div>
            <DialogTitle className="font-serif text-3xl md:text-4xl text-charcoal mt-4 text-left">
              Für meinen Vater
            </DialogTitle>
            <DialogDescription id="example-desc" className="sr-only">
              Vollständiger anonymisierter Trauerrede-Entwurf als Beispiel.
            </DialogDescription>
          </DialogHeader>
          <div className="mt-8 font-serif italic text-lg text-charcoal leading-[1.85] whitespace-pre-line">
            {SAMPLE_FULL}
          </div>
          <div className="mt-10 pt-8 border-t border-umber/10 font-display tracking-[0.25em] text-[10px] text-umber">
            — Anonymisiertes Beispiel
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
